import { sortByCachedKey } from "@thi.ng/arrays";
import { compareNumAsc, compareNumDesc } from "@thi.ng/compare";
import { distHSV, distRGB } from "./distance";
export const selectChannel = (id) => (col) => col[id];
export const proximityHSV = (target) => (col) => distHSV(target, col);
export const proximityRGB = (target) => (col) => distRGB(target, col);
export const sortColors = (cols, key, isReverse = false) => sortByCachedKey(cols, key, isReverse ? compareNumDesc : compareNumAsc);
